import PropTypes from 'prop-types';

export const projectSummary = PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  intervention_zone_id: PropTypes.number.isRequired
});